import Content from '../AllPageContent/AllPageContent';
import "./classquestion.css";

function ClassQuestion({ paragraphs }) {
    return (
        <>
            <div className='p-1'>
                <div className=' classquestion- px-sm-5 py-sm-4 p-2 px-1 '>
                    <Content paragraphs={paragraphs} />
                </div>
            </div>
        </>
    )
}

export default ClassQuestion
